import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "vechile-details-list" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "label-block" }
const _hoisted_4 = { class: "label-block_label" }
const _hoisted_5 = { class: "input-block" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-10" }
const _hoisted_8 = { class: "form-block" }
const _hoisted_9 = { class: "label-block" }
const _hoisted_10 = { class: "label-block_label" }
const _hoisted_11 = { class: "input-block" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-10" }
const _hoisted_14 = { class: "form-block" }
const _hoisted_15 = { class: "label-block" }
const _hoisted_16 = { class: "label-block_label" }
const _hoisted_17 = { class: "label-block_question position-relative" }
const _hoisted_18 = { class: "tooltip-content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_20 = { class: "input-block" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = { class: "form-block" }
const _hoisted_24 = { class: "label-block" }
const _hoisted_25 = { class: "label-block_label" }
const _hoisted_26 = { class: "label-block_question position-relative" }
const _hoisted_27 = { class: "tooltip-content" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_29 = { class: "input-block" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-10" }
const _hoisted_32 = { class: "country-select" }
const _hoisted_33 = { class: "d-flex align-items-center mb-3" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "d-block ms-4" }
const _hoisted_36 = { class: "form-block" }
const _hoisted_37 = { class: "label-block" }
const _hoisted_38 = { class: "label-block_label" }
const _hoisted_39 = { class: "input-block" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-10" }
const _hoisted_42 = { class: "form-block" }
const _hoisted_43 = { class: "label-block" }
const _hoisted_44 = { class: "label-block_label" }
const _hoisted_45 = { class: "input-block-phone" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-10" }
const _hoisted_48 = { class: "form-block" }
const _hoisted_49 = { class: "label-block" }
const _hoisted_50 = { class: "label-block_label" }
const _hoisted_51 = { class: "input-block" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-10" }
const _hoisted_54 = { class: "submit-btn text-md-end text-center" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-lg-10" }
const _hoisted_57 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vc_date_picker = _resolveComponent("vc-date-picker")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "ruleFormRef",
    model: _ctx.bike,
    "status-icon": "",
    rules: _ctx.rules,
    class: "demo-ruleForm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('bike_year')) + " * ", 1)
            ])
          ]),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.bike_year_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 0,
                      to: `#${_ctx.bike_year_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.year_search,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year_search) = $event)),
                        placeholder: "Search ..",
                        ref: "year_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.bike_engine_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 1,
                      to: `#${_ctx.bike_engine_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.engine_search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.engine_search) = $event)),
                        placeholder: "Search ..",
                        ref: "engine_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true),
                (_ctx.country_id)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 2,
                      to: `#${_ctx.country_id}`
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.country_search,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.country_search) = $event)),
                        placeholder: "Search ..",
                        ref: "country_search_ref",
                        style: {"position":"absolute","top":"0px"}
                      }, null, 8, ["modelValue"])
                    ], 8, ["to"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, { prop: "bike_year" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.bike.bike_year,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bike.bike_year) = $event)),
                      placeholder: `${_ctx.$t('bike_year')}`,
                      class: "select-input",
                      "default-first-option": "",
                      filterable: !_ctx.isMobile,
                      onChange: _ctx.resetAll,
                      "popper-class": {'bike_year_teleport': _ctx.isMobile},
                      onClick: _ctx.alertYear
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_year, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.yearsList, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "filterable", "onChange", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", { ref: "model_details" }, _toDisplayString(_ctx.$t('engine_capacity')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form_item, { prop: "engine_capacity" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.bike.engine_capacity,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bike.engine_capacity) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: `${_ctx.$t('engine_capacity')}`,
                      class: "select-input",
                      "default-first-option": "",
                      "popper-class": {'bike_engine_teleport': _ctx.isMobile},
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.engine_search = '')),
                      onClick: _ctx.alertEngine
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_engine, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "bike",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.trimLevels, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "bike",
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "placeholder", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('bike_emirates')) + " *", 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('bike_emirates_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_form_item, { prop: "registration_emirate" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.bike.registration_emirate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bike.registration_emirate) = $event)),
                      filterable: "",
                      class: "select-input",
                      placeholder: `${_ctx.$t('emirates_placeholder')}`
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emirate, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            class: "vehicle",
                            key: index,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createVNode(_component_vc_date_picker, {
          isRequired: "",
          "model-value": _ctx.bike.dob,
          "onUpdate:model-value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bike.dob) = $event)),
          "is-tooltip": "",
          "tooltip-message": _ctx.$t('dob'),
          "form-prop": "dob",
          label: _ctx.$t('date_of_birth'),
          ref: "dob",
          max: _ctx.dobMaxDate,
          default: _ctx.dobMaxDate
        }, null, 8, ["model-value", "tooltip-message", "label", "max", "default"]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", { ref: "nation" }, _toDisplayString(_ctx.$t('nationality')) + " * ", 513)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('nationality_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_el_form_item, { prop: "nationality" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.bike.nationality,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bike.nationality) = $event)),
                        filterable: "",
                        placeholder: _ctx.language === 'ar' ? 'الجنسية' : 'Nationality',
                        class: "select-input",
                        onChange: _ctx.selectedNationality
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nationalities, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: _ctx.language === 'ar' ? item.label_ar : item.label,
                              value: item.value,
                              class: "country-list-item"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_el_avatar, {
                                    size: 40,
                                    class: "d-block"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: `/img/flags/${item.code.toLowerCase()}.svg`
                                      }, null, 8, _hoisted_34)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.language === 'ar' ? item.label_ar : item.label), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onChange"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vc_date_picker, {
          isRequired: "",
          "model-value": _ctx.bike.policy_start_date,
          "onUpdate:model-value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bike.policy_start_date) = $event)),
          "is-tooltip": "",
          "tooltip-message": _ctx.$t('policy_start_date_tool_tip'),
          "form-prop": "policy_start_date",
          label: _ctx.$t('policy_start_date'),
          ref: "policy_start_date",
          min: _ctx.todayDate,
          max: _ctx.policyStartMaxDate
        }, null, 8, ["model-value", "tooltip-message", "label", "min", "max"]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", { ref: "full_name" }, _toDisplayString(_ctx.$t('full_name')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_el_form_item, { prop: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.bike.name,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bike.name) = $event)),
                      placeholder: `${_ctx.$t('full_name_paceholder')}`,
                      maxlength: "62",
                      onkeydown: _ctx.language === 'en' ? `return /[a-zA-Z_ \s'-]/i.test(event.key)` : ''
                    }, null, 8, ["modelValue", "placeholder", "onkeydown"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", { ref: "phone" }, _toDisplayString(_ctx.$t('phone_number')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_el_form_item, { prop: "phone_number" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.bike.phone_number,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bike.phone_number) = $event)),
                      modelModifiers: { number: true },
                      type: "tel",
                      maxlength: "10",
                      pattern: "[0-9]*",
                      placeholder: `${_ctx.$t('phone_number_placeholder')}`,
                      id: "phone_number",
                      disabled: _ctx.disablePhoneNumber || _ctx.disableLqId,
                      oninput: "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/[^0-9]/g, '')"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.bike.phone_country_code,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bike.phone_country_code) = $event)),
                          filterable: !_ctx.isMobile,
                          placeholder: "",
                          class: "country",
                          disabled: _ctx.disablePhoneNumber || _ctx.disableLqId,
                          "popper-class": {'country_teleport': _ctx.isMobile},
                          onClick: _ctx.alertCountry,
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.country_search = ''))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isMobile)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_country, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.text,
                                    value: item.text
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (!_ctx.isMobile)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.country, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.text,
                                    value: item.text
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "filterable", "disabled", "popper-class", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("label", { ref: "email_address" }, _toDisplayString(_ctx.$t('email')) + " * ", 513)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_el_form_item, { prop: "email" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.bike.email,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bike.email) = $event)),
                      placeholder: `${_ctx.$t('email_placeholder')}`,
                      maxlength: "62",
                      ref: "emailRef",
                      onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isEmailExist = null))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              class: "btn",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleClick(_ctx.ruleFormRef))),
              "element-loading-background": "rgba(0, 0, 0, 0.4)",
              disabled: _ctx.isClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('proceed')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])), [
              [
                _directive_loading,
                _ctx.isClick,
                void 0,
                {
                  fullscreen: true,
                  lock: true
                }
              ]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}